<template>
  <div style="background-color:white;margin-top:12px">
    <draggable v-model="items" :options="{handle:'.lp-drag-btn'}" @update="test">
      <div v-for="(stepform,idx) in items" :key="'stepform-'+idx"
           class="lp-step-form" @click="clickForm(stepform)"
           :class="{'lp-step-form-clicked':stepform.clicked}">
        <div class="lp-drag-btn"><i class="material-icons">dehaze</i></div>
        <!-- 타입별 요소 -->
        <div class="flex-justify">
          <div style="margin-right: 20px;flex:1">
            <input v-model="stepform.question" placeholder="질문을 입력해주세요">
          </div>
          <!-- 요소 선택 -->
          <div>
            <form-element-dr-dn :ele="stepform.type" :formtypes="formtypes"
                                @clickEl="res => clickEl(stepform, res)"></form-element-dr-dn>
          </div>
        </div>

        <div v-if="stepform.type.search('text')>-1 || stepform.type.search('number')>-1">
          <input v-model="stepform.placeholder" placeholder="Placeholder 입력">
        </div>

        <div v-if="stepform.type.search('number')>-1">
          <lp-check-bool :checkedVal.sync="stepform.enable_option" label="입력 가능한 최소~최대값 설정" style="margin:8px 0"></lp-check-bool>
          <div class="flex-align" v-if="stepform.enable_option">
            <input class="stepform-input-number" v-model="stepform.min" @input="e=>stepform.min=parseInt(e.target.value)" type="number" placeholder="최소값">
            <span style="margin:0 4px">~</span>
            <input class="stepform-input-number" v-model="stepform.max" @input="e=>stepform.max=parseInt(e.target.value)" type="number" placeholder="최대값">
          </div>
        </div>

        <!-- 옵션 입력 -->
        <div class="lp-opt-div" v-for="(opt, opt_idx) in stepform.opts" :key="'opt-'+opt_idx">
          <div :class="optIcon(stepform.type)"><span v-if="stepform.type === 'dropdown'">{{ opt_idx+1 }}</span></div>
          <div style="flex:1" v-if="opt.value !== 'etc..'"><input v-model="opt.value" placeholder="옵션을 입력해주세요." ></div>
          <div style="flex:1;padding-top:15px" v-else>기타</div>
          <div class="btn-del" v-if="opt_idx > 0" @click="deleteOpt(stepform.opts, opt_idx)"><i class="material-icons">close</i></div>

          <text-tip @clicked="addOptForm(opt)"
                    :textStyle="{'fontSize':'10px','color':'#4f4f4f','textDecoration':'underline','marginLeft':'8px'}"
                    title="연관 질문 만들기"
                    v-if="stepform.type!=='checkbox'"
                    description="이 옵션 선택 시 입력해야하는 질문을 생성합니다."></text-tip>
          <!--<div class="relative-form-btn" @click="addOptForm(opt)">연관 질문 만들기</div>-->
        </div>
        <div style="display:flex" v-if="stepform.opts.length>0">
          <div :class="optIcon(stepform.type)"><span v-if="stepform.type === 'dropdown'">{{ stepform.opts.length + 1 }}</span></div>
          <div class="add-opt-txt" @click="addOpt(stepform.opts)">옵션 추가</div>
          <div class="add-opt-etc" v-if="!vEtc(stepform.opts)" @click="addOptEtc(stepform.opts)">기타 추가</div>
        </div>

        <!-- 범위 -->
        <div v-if="stepform.type === 'linear'" class="flex">
          <lp-dropdown :options="opts.min" :ele.sync="stepform.range.min.val"></lp-dropdown> <div class="wave"> ~ </div>
          <lp-dropdown :options="opts.max" :ele.sync="stepform.range.max.val"></lp-dropdown>
        </div>
        <div v-if="stepform.type === 'linear'">
          <div class="flex"><div class="range-label-title">{{ stepform.range.min.val }}</div><input v-model="stepform.range.min.label"></div>
          <div class="flex"><div class="range-label-title">{{ stepform.range.max.val }}</div><input v-model="stepform.range.max.label"></div>
        </div>

        <!-- 토글 -->
        <div class="lp-toggle">
          <div class="lp-toggle-item" @click="copyForm(stepform, idx)"><i class="material-icons">content_copy</i></div>
          <div class="lp-toggle-item" @click="removeForm(idx)"><i class="material-icons">delete</i></div>
          <div class="lp-toggle-in">
            <div style="display: table-cell">
              <toggle-button @change="e=>setRequired(stepform, e)" :sync="true"
                             :value="stepform.required" class="changed-font" :width="70" :height="24"
                             :labels="{'checked':'필수', 'unchecked':'옵션'}"></toggle-button>
            </div>
            <div style="display: table-cell" v-if="visible">
              <div style="margin-left:8px">
                <toggle-button @change="e=> stepform.visible = e.value" :sync="true"
                               :value="stepform.visible" class="changed-font" :width="70" :height="24"
                               :labels="{'checked':'노출', 'unchecked':'비노출'}"></toggle-button>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top:50px">
          <div class="opt-list-wrapper" style="margin-bottom:16px" v-for="(opt,idx) in opt_list" :key="'opt-'+idx" v-if="existUid(stepform, opt)">
            <div class="flex-between">
              <span class="opt-title">{{ opt.value }} 선택 시 노출</span>
              <div class="btn-del" @click="deleteOptItem(opt, idx)"><i class="material-icons">close</i></div>
            </div>
            <block-forms :forms.sync="opt.forms" :saveAction="saveAction" :visible="false"
                         @update:doAction="doAction"></block-forms>
          </div>
        </div>
      </div>
      <div style="text-align: center" slot="footer">
        <div class="btn-add" @click="addStepForm">질문 추가 +</div>
      </div>
    </draggable>
    <!--<div style="margin-top:50px">
      <div class="opt-list-wrapper" style="margin-bottom:16px" v-for="opt,idx in opt_list" :key="'opt-'+idx">
        <div class="flex-between">
          <span class="opt-title">{{ opt.value }} 선택 시 노출</span>
          <div class="btn-del" @click="deleteOptItem(opt, idx)"><i class="material-icons">close</i></div>
        </div>
        <block-forms :forms="opt.forms" :saveAction="saveAction" @save="addOptFromForms"></block-forms>
      </div>
    </div>-->
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import FormElementDrDn from '../../../../module/common/FormElementDrDn'
  import LpDropdown from '../../../../module/common/LpDropdown'
  import LpSortDropDown from "../../../../module/common/LpSortDropDown";
  import LpAdmDropInput from "../../../../module/common/LpAdmDropInput";
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import uuidv4 from 'uuid/v4'
  import TextTip from "../../../../module/common/TextTip";
  export default {
    name: "block-forms",
    components: {
      TextTip,
      LpCheckBool,
      LpAdmDropInput,
      LpSortDropDown,
      draggable,
      FormElementDrDn,
      LpDropdown
    },
    props: {
      forms: {
        type: Array,
        required: false
      },
      // 저장하기 액션시 true
      saveAction: {
        type: Boolean,
        required: true
      },
      visible: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data () {
      return {
        // selectedForm: undefined
        items: this.forms,
        formtypes: [
          {
            icon: "short_text",
            id: 1,
            name: "단답형",
            types: "text",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "subject",
            id: 2,
            name: "장문형",
            types: "textarea",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "radio_button_checked",
            id: 3,
            name: "객관식 질문",
            types: "radio",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "check_box",
            id: 4,
            name: "체크박스",
            types: "checkbox",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "arrow_drop_down_circle",
            id: 5,
            name: "드롭다운",
            types: "dropdown",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "cloud_upload",
            id: 6,
            name: "파일 업로드",
            types: "fileupload",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "insert_invitation",
            id: 7,
            name: "날짜",
            types: "date",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "linear_scale",
            id: 8,
            name: "직선단계",
            types: "linear",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "access_time",
            id: 9,
            name: "시간",
            types: "time",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "place",
            id: 10,
            name: "지역",
            types: "region",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "person",
            id: 11,
            name: "사용자 정보",
            types: "users",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "place",
            id: 12,
            name: "가능 지역",
            types: "address",
            updated_date: "2018-01-12T08:30:33.585Z"
          }, {
            icon: "looks_one",
            id: 13,
            name: "숫자 단답형",
            types: "number",
            updated_date: "2018-01-12T08:30:33.585Z"
          }
        ],
        // 범위 옵션 용
        opts: {
          min: [],
          max: []
        },
        opt_list: [],
        is_first: true
      }
    },
    created () {
      this.items = this.forms;
      //범위용 드롭다운 데이터 생성
      for(let i=0; i<=10; i++) {
        if(i<2) this.opts.min.push({ value:i, label:i });
        else this.opts.max.push({ value:i, label:i });
      }

      this.$nextTick(() => {
        this.getOptList(this.forms);
      });
    },
    watch: {
      saveAction (n) {
        if(n) {
          this.addOptFromForms();
        }
      },
      forms: {
        handler(n) {
          this.items = n;
        },
        deep: true
      },
      items: {
        handler(n) {
            if(this.is_first) {
              this.getOptList(n);
              this.is_first = false;
            }
            else this.$emit('update:doAction');
            this.$emit('update:forms', n);
        },
        deep: true
      },
      // forms: {
      //   handler(n) {
      //     if(this.is_first) {
      //       this.getOptList(this.forms);
      //       this.is_first = false;
      //     }
      //     else this.$emit('update:doAction');
      //   },
      //   deep: true
      // },
      /*forms (n) {
        if(this.is_first) {
          this.getOptList(this.forms);
          this.is_first = false;
        }
        else this.$emit('update:doAction');
      }*/
      // 'forms' (n) {
      //   console.log(n)
      //   this.$emit('update:doAction');
      // }
    },
    methods: {
      setRequired(form, e) {
        form.required = e.value;
        form.valid_required = e.value;
      },
      test(e) {
        console.log(e)
      },
      existUid (stepform, opt) {
        let opt_item = find(stepform.opts, 'uid', opt.uid);
        return !!opt_item;
      },
      deleteOpt (opts, opt_idx) {
        let opt_uid = opts[opt_idx].uid;
        for(let i=0; i<this.opt_list.length; i++) {
          if(opt_uid===this.opt_list[i].uid) {
            removeIndex(this.opt_list, i);
            break;
          }
        }
        removeIndex(opts, opt_idx);
        // this.$emit('update:doAction')
        // removeIndex(this.stepform.opts,opt_idx)

      },
      doAction () {
        this.items.forEach(form => {
          form.opts.forEach(opt => {
            let optItem = find(this.opt_list, 'uid', opt.uid);
            if(opt.forms) opt.forms = optItem.forms;
          })
        })
      },
      // option_list에서 구성한 opt들을 forms에 저장
      async addOptFromForms () {
        this.items.forEach(form => {
          form.opts.forEach(opt => {
            let optItem = find(this.opt_list, 'uid', opt.uid);
            if(optItem && opt.forms) opt.forms = optItem.forms;
          })
        })
        this.$emit('saveData');
      },
      deleteOptItem (selectedOpt, idx) {
        this.items.forEach(form => {
          form.opts.forEach(option => {
            if(selectedOpt.uid===option.uid) {
              delete option.uid;
              delete option.forms;
              removeIndex(this.opt_list,idx);
            }
          })
        })
      },
      // 폼에 있는 옵션 목록 가져와서 opt_list에 저장
      getOptList (forms) {
        let result = [];
        forms.forEach(form => {
          // console.log('opts', form.opts)
          form.opts.forEach(opt => {
            // console.log('opt', opt)
            if(opt.uid) {
              result.push(opt);
              // this.getOptForms(opt.forms);
            }
          })
        })
        // console.log('result', result);
        this.opt_list = this.cloneItem(result);
      },
      //폼 선택
      clickForm(forms) {
        if(this.selectedForm !== undefined)
          this.selectedForm.clicked = false;

        forms.clicked = true;
        this.selectedForm = forms;
      },
      // 타입 선택
      clickEl(el, type) {
        el.type = type;
        // 옵션 없는 타입
        let not_opts = ['text', 'textarea', 'fileupload', 'linear', 'region','users', 'address', 'number'];

        if(el.type==='number') {
          el.enable_option = false;
        }

        if(not_opts.indexOf(type) === -1) {
          el.opts = [{
            value: '옵션 1'
          }];
        }
        else {
          el.opts = [];
        }
        // this.opt_list = [];
      },
      // 연관 질문 만들기
      addOptForm (opt) {
        if(!opt.uid) {
          opt.forms = [];
          opt.uid = uuidv4();
          this.getOptList(this.forms);
        }

        // opt.forms = [];
        // opt.uid = uuidv4();
        // this.getOptList(this.forms);
      },
      // 옵션 추가
      addOpt(opts) {
        opts.push({
          value: '옵션 ' + (opts.length+1)
        })
      },
      // 옵션 기타 추가
      addOptEtc(opts) {
        opts.push({
          value: 'etc..'
        })
      },
      //기타 항목 추가여부
      vEtc(opts) {
        let hasEtc = false;
        for(let i=0; i< opts.length; i++) {
          if(opts[i].value === 'etc..') {
            hasEtc = true;
            break;
          }
        }

        return hasEtc;
      },
      optIcon(type) {
        switch(type) {
          case 'radio': return 'lp-circle';
          case 'checkbox': return 'lp-square';
          case 'dropdown': return 'lp-drdn';
        }
      },
      // 스텝 폼 추가
      addStepForm() {
        this.items.push({
          type: 'text',
          placeholder: '',
          clicked: false,
          required: true,
          valid_required: true,
          visible: true,
          opts:[],              // 옵션(체크박스, 라디오, 드롭다운)
          range: {              // 범위(직선단계)
            min: {
              val: 1,
              label: ''
            },
            max: {
              val: 5,
              label: ''
            }
          },
          enable_option: false
        })
        // this.$emit('update:doAction')
      },
      //폼 복사
      copyForm(stepform, idx) {
        let forms = this.cloneItem(stepform);
        forms.selected = false;
        // this.selectedStep.step.forms.splice(idx+1, 0, forms);
        this.items.splice(idx+1, 0, forms);
      },
      //폼 삭제
      removeForm(idx) {
        // removeIndex(this.selectedStep.step.forms,idx);
        removeIndex(this.items,idx);
        // this.$emit('update:doAction')
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .lp-content input
    border 0
    border-bottom 1px solid #ddd
    padding 8px 0
    padding-bottom 2px
    border-radius 0
    font-size 0.9rem
    max-width 400px
    box-shadow 0 0 0
  .lp-content input:focus
    border-bottom 1px solid $primary

  input[type=checkbox]
    width unset
    height 0.82rem

  input
    width 100%

  label
    font-size 0.9rem

  .lp-step-form
    padding 20px

  .lp-step-form-clicked
    box-shadow 0px 4px 6px 2px #aaa

  .btn-add
    padding 4px 20px
    border-radius 50px
    color $primary
    border 1px solid $primary
    text-align center
    margin 20px auto
    display inline-block
    cursor pointer

  .lp-opt-div
    width 400px
    display flex
    justify-content space-between
    padding 8px 0
    align-items center

  .lp-opt-div input
    flex 1

  .flex-justify
    display flex
    justify-content space-between
    margin-bottom 20px

  .lp-drdn
  .lp-circle
  .lp-square
    width 16px
    height 16px
    /*margin-top 14px*/
    margin-right 8px

  .lp-circle
    border-radius 100%

  .lp-circle
  .lp-square
    border 2px solid #aaa

  .btn-del
    /*margin-top 8px*/
    color #999

  .add-opt-etc
  .add-opt-txt
    color #555
    margin-top 15px
    font-size 0.9rem
    cursor pointer

  .add-opt-etc
    margin-left 8px
    color $primary

  .lp-toggle
    display flex
    justify-content flex-end
    margin-top 30px
    padding 20px 0
    border-top 1px solid #ddd

  .lp-toggle-item
    margin 0 12px
    color #555

  .lp-toggle-in
    display table
    padding-left 16px
    border-left 1px solid #eee


  .vue-js-switch .v-switch-label
    font-weight 400

  .vue-js-switch.changed-font
    font-size 14px

  .wave
    line-height 43px
    margin 0 8px

  .range-label-title
    height 23px
    width 30px
    text-align center
    padding-top 16px

  .lp-drag-btn
    width 100%
    height 20px
    text-align center
    margin-bottom 12px

  .lp-drag-btn i
    color #787878
    font-size 0.9rem
    display none

  .lp-step-form:hover .lp-drag-btn i
    display block
    cursor move

  .catlabel
    margin-right 4px
    padding 4px
    font-size 0.9rem
    background-color $primary
    color white
    border-radius 3px

  .relative-form-btn
    font-size 10px
    color #4f4f4f
    text-decoration underline
    margin-left 8px

  .btn-del,
  .relative-form-btn
    cursor pointer

  .opt-list-wrapper
    background-color #f3f3f3
    border 1px solid #e5e5e5
    border-radius 6px
    padding 8px

  .opt-title
    padding 4px
    border-radius 11px
    color white
    background-color #d5d5d5

  .stepform-input-number
    width 83px
    height 28px
    border 1px solid #ddd !important
    border-radius 3px !important
    padding 8px !important
    text-align left !important
</style>
